import type { NavItemProps } from "./nav-item";
import { useLocation } from "react-router";


export const useNavItemActive = (item: NavItemProps): boolean => {
	const location = useLocation();

	switch(item.kind) {
		case "route":
			return item.matches?.(location.pathname) ?? location.pathname.startsWith(item.path);
		case "menu":
			return item.items.some(useNavItemActive);
		default:
			return false;
	}
};
